export const monikaKruszyna = {
    'firstName': 'Monika',
    'lastName': 'Kruszyna',
    'profession': 'Psycholog, psychoterapeuta behawioralno-poznawczy w trakcie szkolenia',
    'avatar': 'monika-kruszyna.webp',
    'slug': 'psycholog-psychoterapeuta-monika-kruszyna',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'adult'],
        ['psychology', 'consultation'],
    ]
}